import { connect } from 'react-redux';
import ProjectsDashboard from './ProjectsDashboard';
import { setProjects } from '../common/projects/actions';
import { createProjectToken, deleteProjectToken } from '../common/projectstatus/actions';


const mapStateToProps = state => ({
    isLocked: state.isLockedUI.isLocked,
    projects: state.projects,
    projectToken: state.projectstatus.projectToken,
    authToken: state.auth.authToken,
    companyName: state.clientInfoUI.companyName,
    firstName: state.contactUI.firstName,
    lastName: state.contactUI.lastName,
    clientId: state.addClientUI.clientId,
});


const mapDispatchToProps = dispatch => ({
    setProjects: projects => dispatch(setProjects(projects)),
    createProjectToken: (authToken, projectId) =>
        dispatch(createProjectToken(authToken, projectId)),
    deleteProjectToken: (authToken, projectId) =>
        dispatch(deleteProjectToken(authToken, projectId)),
});


export default connect(mapStateToProps, mapDispatchToProps)(ProjectsDashboard);



// WEBPACK FOOTER //
// ./src/containers/ProjectsDashboard/index.js